import { buildHeaders } from "./api";

const BASE_URL = process.env.REACT_APP_API_BASE?.replace(/\/$/, "");

async function bookRequest(projectId, scope, token, options = {}) {
  if (!BASE_URL) throw new Error("The backend address is not configured.");
  const url = new URL(`${BASE_URL}/projects/${encodeURIComponent(projectId)}/market-bid-book`);
  if (!options.body) Object.entries(scope).forEach(([key, value]) => url.searchParams.set(key, value));
  const response = await fetch(url.toString(), {
    ...options,
    headers: await buildHeaders(token, { "Content-Type": "application/json" }),
    ...(options.body ? { body: JSON.stringify({ ...scope, ...options.body }) } : {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = result.detail;
    const message = typeof detail === "string" ? detail : detail?.message;
    throw new Error(message || (Array.isArray(detail) ? detail.map((item) => item.msg).join("; ") : "Could not load or save the bid book."));
  }
  return result;
}

export const loadMarketBidBook = (projectId, scope, token, signal) =>
  bookRequest(projectId, scope, token, { signal });
export const saveMarketBidBook = (projectId, scope, body, token) =>
  bookRequest(projectId, scope, token, { method: "PUT", body });

export function serializeBidBook(book) {
  return JSON.stringify({
    format: "pythia-bid-book-review-v1",
    purpose: "Draft for review; not an exchange submission file",
    project_id: book.project_id,
    asset_id: book.asset_id,
    delivery_day: book.delivery_day,
    bidding_zone: book.bidding_zone,
    trading_market: book.trading_market,
    timezone: book.timezone,
    market_timezone: book.market_timezone,
    price_unit: book.market?.price_unit,
    periods: book.periods?.map(({ index, start, end, available }) => ({ index, start, end, available })),
    revision: book.revision,
    configuration_version_id: book.configuration_version_id,
    rules_version: book.rules_version,
    status: "draft",
    orders: book.orders,
  }, null, 2);
}
